import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApplicationActions } from "@MasterBluePrint/Store/CustomApplicationState";
import { DispatchProp } from "react-redux";

interface Parameter {
    countryCode: string;
}

type HandlerType = Handler<Parameter, DispatchProp<CustomApplicationActions>>;

export const DispatchSetCountryCode: HandlerType = props => {
    props.dispatch({
        type: "Components/CustomCountry/SetCountryCode",
        countryCode: props.parameter.countryCode
    });
};

export const chain = [
    DispatchSetCountryCode
];

const setCountryCode = createHandlerChainRunner(chain, "SetCountryCode");
export default setCountryCode;
